<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
  </div>
</template>
<script>
export default {
  name: 'Home',
  data () {
    return {
      msg: 'Pay Home'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue